import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { Layout } from '../layout/Layout';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return <Layout>{children}</Layout>;
} 